
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild,Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-district-dialog-box',
  templateUrl: './district-dialog-box.component.html',
  styleUrls: ['./district-dialog-box.component.scss']
})
export class DistrictDialogBoxComponent implements OnInit {
  displayColumns = [ 'DistrictCode', 'DistrictName'];
  showpdfbtn=false;
  showcsvbtn=false;
  bydefaultbtn=true
  DistrictForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  showBtn=false;
  showBtn1=false;
  districtList: any;
  DsCode: any;
  DsName: any;
  isreadonlydel = false;
  isReadOnlyCode = false;
  district: string;
  list;
  districtform: any;
  DistrictSearchForm;
  APIService: any;
  deleteButton: boolean;
  DsCodefordelete;
  isreadonly = true;
  dialogRef: MatDialogRef<any>;
  userPermission:any;
  utp: any;
  DisCreate = true;
DisUpdate = true;
DisDelete = true;
StateCodeList
filteredListState
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    
   private dialogRef2:MatDialogRef<DistrictDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
              private fb: FormBuilder,   public router: Router, private httpClient: HttpClient,
              private route: ActivatedRoute, private spinner:NgxSpinnerService, ) {this.APIService = environment.serviceUrl; }
 
  

  // download(){
  //   let wwe =['FcCode','FcDesc']
  //   this.umsService.downloadFile(this.facultyList, 'jsontocsv', wwe);
  // }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
  this.utp = sessionStorage.getItem('usertypeee');
  if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
    // this.isSuperAdmin= false;
    this.userPermission.forEach(element => {
    if(element.PageName == 'District' && element.PCreate == false)
    {
        this.DisCreate = false;  
    }
    if(element.PageName == 'District' && element.PUpdate == false)
    {
        this.DisUpdate = false;  
    }   
    if(element.PageName == 'District' && element.PDelete == false)
    {
        this.DisDelete = false;  
    } 
  });
}
    window.scroll(0, 0);
    this.DsCodefordelete = 0;
    this.submitButton = true;
    this.editButton = false;
    this.isreadonly = false;
    this.bydefaultbtn=true;
    this.showpdfbtn=false;
  this.showcsvbtn=false;
    this.getDistrictData();
    this.getStateData();
    this.list = true;
    this.DistrictForm = this.fb.group({
      DsStateCode: new FormControl('', [Validators.required]),
      DsCode: new FormControl('',  [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')]),
      DsName: new FormControl('', [Validators.required]),

    });
    this.DistrictSearchForm = this.fb.group({
      SearchString: new FormControl ('')
    });
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.deletee(this.data.selected.DsCode);
    } else {
      // alert(this.data.key)
    }
  }

  getDistrictData() {
 this.spinner.show();
        const payload = {};
        this.umsService.getDistrict(payload).subscribe(res => {
      this.districtList = res.data;
      this.spinner.hide();
    }, (ERROR: HttpErrorResponse) => {
      this.districtList = [];
      let  data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.umsService.openSnackbar(ERROR.error.message);

   });
  }

  prepopulation(id) {
    this.editButton = true;
    this.isreadonly = true;
    this.submitButton = false;
    this.deleteButton = false;
    this.isReadOnlyCode = true;
    this.DistrictForm = this.fb.group({
      DsStateCode: new FormControl(id.DsStateCode, [Validators.required]),
      DsCode: new FormControl(id.DsCode, [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')]),
      DsName: new FormControl(id.DsName, [Validators.required]),
    });
  }



  deletedata(id){
    const options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),  body: {
      DsName: id.DsName,
      DsCode: id.DsCode,
      DsStateCode:id.DsStateCode,
    },
  };
    this.httpClient.delete(this.APIService + '/masters/district', options)
    .subscribe((s) => {
      // this.spinner.hide();
      let cc = [];
      cc.push(s);
      let  data = {}
      data['message'] = cc[0].message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        // this.dialogRef.close();
        // this.ngOnInit();
        this.dialogRef2.close();
      });
    },(ERROR: HttpErrorResponse) => {

      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.dialogRef.close();
      // this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);
      this.dialogRef2.close();
   });

   }


   deletee(k){
    // if (e === 'true'){
      this.list = false;
      this.getDistrictData(); 
      const payload = {};
       payload['DsCode'] = k;
        // payload['DsName'] = k;
      this.umsService.getDistrict(payload).subscribe((res) => {
        const data = res.data[0];
        if (res.status) {
          this.editButton = false;
          this.submitButton = false;
          this.isreadonlydel = true;
          this.isReadOnlyCode = true;
          this.deleteButton = true;
          this.DistrictForm = this.fb.group({
            DsStateCode :new FormControl(data.DsStateCode, [Validators.required]),
            DsCode: new FormControl(data.DsCode, [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')]),
            DsName: new FormControl(data.DsName, [Validators.required]),
          });
          this.DsCodefordelete =  this.DistrictForm.value;
        } else {
          let  data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-box-open'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      });
    // } else {
    //   this.list = true;
    // }
  }
  openConformationModalBox(){
    let  data = {}
    data['message'] = 'Are You Sure You Want To Delete This Record ?'
    data['title'] = 'Alert'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if(result == 'yes'){
        this.deletedata(this.DsCodefordelete);
      }
    });
   }

  keypress(){
    this.umsService.searchDistrict(this.DistrictSearchForm.value).subscribe(res => {
      this.districtList = res.data;
      }, (ERROR: HttpErrorResponse) => {
        this.districtList = [];
      });
  }

  submit() {
    if (this.DistrictForm.invalid) {
      this.DistrictForm.get('DsCode').markAsTouched();
      this.DistrictForm.get('DsName').markAsTouched();
      this.DistrictForm.get('DsStateCode').markAsTouched();
      return;
    } else {
      this.createDistrict();
    }

  }

  

  createDistrict() {
    this.spinner.show();
    this.submitpayload = this.DistrictForm.value;
    this.umsService.addDistrict(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      } else { 
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
         this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
        });
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.districtList = [];
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
   });
  }

  update() {
    if (this.DistrictForm.invalid) {
      this.DistrictForm.get('DsCode').markAsTouched();
      this.DistrictForm.get('DsName').markAsTouched();
      this.DistrictForm.get('DsStateCode').markAsTouched();
      return;
    } else {
      this.updateDistrict();
    }
  }

  updateDistrict() {
    this.spinner.show();
    this.submitpayload = this.DistrictForm.value;
    this.umsService.updateDistrict(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
         // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      } else {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
         // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }
    });
  }

  addnewrecord(e){
    if (e === 'true'){
      this.list = false;
      this.submitButton = true;
      this.isreadonly = false;
      this.editButton = false;
      this.isreadonlydel = false;
      this.isReadOnlyCode = false;
      this.deleteButton = false;
      this.DistrictForm.reset();
      // this.DistrictForm = this.fb.group({
      //   DsCode: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-z0-9]*$')]),
      //   DsName: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-Z-&\\s]*$')]),
      // });
    } else {
      this.list = true;
      this.getDistrictData();
      this.ngOnInit();
    }
  }

  editdata(e, k){
    if (e === 'true'){
      this.list = false;
      // this.isreadonly = false;
      // this.getDistrictData();
      // this.DistrictForm = k;
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
   }

   download(){
    this.showBtn=false;
    this.showBtn1=true;
    const wwe = ['DsCode', 'DsName'];
    this.umsService.downloadFile(this.districtList, 'jsontocsv', wwe);
  }
   globalPrint(){
    this.showBtn=true;
    this.showBtn1=false;
    let currentDate =new Date();
    let date=currentDate.toLocaleDateString('en-GB');
    let titleName='District Form.pdf'+date
    var tempTitle = document.title;
    document.title = titleName;
    window.print();
    document.title = tempTitle;
   }
   clickCSV(){
    this.showcsvbtn=true;
    this.showpdfbtn=false;
    this.bydefaultbtn=false;
    // this.download();
   }
   clickPDF(){
    this.showpdfbtn=true;
    this.showcsvbtn=false;
    this.bydefaultbtn=false;
    // this.globalPrint();
   }

   getStateData() {
    this.spinner.show();
    const payload = {};   
    // payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    this.umsService.getState(payload).subscribe(res => {
      this.spinner.hide();
      this.StateCodeList = res.data;
      this.filteredListState = this.StateCodeList.slice();
      // this.totalItems = res.data[0].TotalRecords;
      
    }, (ERROR: HttpErrorResponse) => {
      this.StateCodeList = [];
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }


  
}
